export const boxWrapperStyle = {
  width: '100%',
}

export const tabsWrapperStyle = {
  display: 'flex',
  gap: 3,
}

export const tabStyle = {
  bgcolor: '#FFFFFF',
  flex: 1,
  minWidth: 0,
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
}

export const outletBox = {
  p: 2,
}
